const FieldKeyConstants = {
  D_OTHERS_NOTIFIED_CREDITOR_ADDRESS: 'dcreditorswhohaveclaimssecuredbypropertyfield51',
  D_OTHERS_NOTIFIED_CREDITOR_NAME: 'dcreditorswhohaveclaimssecuredbypropertyfield50',
  D_OTHERS_NOTIFIED_CREDITOR_SELECT: 'dcreditorswhohaveclaimssecuredbypropertyfield68',
  EF_OTHERS_NOTIFIED_CREDITOR_ADDRESS: 'efcreditorswhohaveunsecuredclaimsfield94',
  EF_OTHERS_NOTIFIED_CREDITOR_NAME: 'efcreditorswhohaveunsecuredclaimsfield93',
  EF_OTHERS_NOTIFIED_CREDITOR_SELECT: 'efcreditorswhohaveunsecuredclaimsfield117',
  MASTER_CREDITOR_LIST_CREDITOR_ADDRESS: 'forgea0be5d60656411ef89d8f7647d63bdf0',
  MASTER_CREDITOR_LIST_CREDITOR_ATTN: 'mastercreditorlistfield50',
  MASTER_CREDITOR_LIST_CREDITOR_NAME: 'forge861e1c70656411ef89d8f7647d63bdf0',
  MASTER_CREDITOR_LIST_OMIT_FROM_PDFS_FIELD_KEY: 'mastercreditorlistfield59',
  MASTER_CREDITOR_SELECT: 'mastercreditorlistfield51',
  STATE_OF_FILING: 'districtOfState',
};

export default FieldKeyConstants;
